import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@material-ui/core';
import Logo from './Logo';

const MainNavbar = (props) => {
  return (
    <AppBar
      elevation={0}
      {...props}
    >
      <Toolbar sx={{ height: 56, minHeight: 56 }}>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

export default MainNavbar;
